/**
 * Initializes a testimonials swiper with autoplay and pagination
 * @param {string} sectionId - The unique section identifier
 */
const initTestimonialsSwiper = (sectionId) => {
    const testimonialsSwiper = document.getElementById(`Testimonials-${sectionId}`);
    if (!testimonialsSwiper) return;

    const swiperConfig = {
        loop: true,
        slidesPerView: 1,
        freeMode: {
            enabled: true,
            sticky: true,
        },
        autoplay: {
            delay: 6000,
            disableOnInteraction: false,
            pauseOnMouseEnter: true
        },
        speed: 800,
        pagination: {
            el: `#TestimonialsPagination-${sectionId}`,
            bulletClass: 'testimonials--bullet',
            bulletActiveClass: 'testimonials--bullet--active',
            clickable: true,
            renderBullet: (_, className) => `<span class="${className}"></span>`,
        }
    };

    Object.assign(testimonialsSwiper, swiperConfig);
    testimonialsSwiper.initialize();
};

// Initialize on DOM content loaded
document.addEventListener('DOMContentLoaded', initTestimonialsSwiper);